 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		213: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"23e21f1","1":"f8b81fd","2":"96ae672","3":"e6cf774","4":"1b87041","5":"4c7e6ba","6":"a14d712","7":"39f1d5e","8":"4f6b5a4","9":"90b389c","10":"af3da7f","11":"07bc368","12":"699e1ea","13":"24d04d5","14":"a1c85a1","15":"f8f3c02","16":"17c55e0","17":"7db0ec5","18":"b6248d0","19":"6f3a13c","20":"bb8bc90","21":"51cf3dc","22":"957bd33","23":"4972680","24":"2fc4f45","25":"441df1e","26":"2f42ea4","27":"eeda718","28":"2cb579c","29":"06ec577","30":"e6eaeed","31":"2c0491e","32":"2887ae5","33":"12167fa","34":"3edfac2","35":"0337969","36":"496eca5","37":"f35ca36","38":"de1857e","39":"f72666d","40":"f33075f","41":"046bf14","42":"d344585","43":"7350481","44":"eefe23e","45":"d05b2ab","46":"8758cc5","47":"21da219","48":"cbce7aa","49":"392768e","50":"ba9fdc8","51":"cfc9858","52":"35caccc","53":"af0e8b1","54":"7a68b1f","55":"cbb313f","56":"9348cbc","57":"9c0eca0","58":"da3318b","59":"ac210bd","60":"282f0d8","61":"05df51b","62":"5ae6263","63":"f05a07f","64":"6dabfef","65":"bb3f201","66":"3cf4f9c","67":"ffec7a6","68":"886f0ef","69":"fd7e643","70":"fd46892","71":"ea8e285","72":"1caae74","73":"c3a3b3d","74":"d1a8a35","75":"0211fc8","76":"a1ca685","77":"ba50020","78":"5a458ef","79":"546e5f2","80":"4c97225","81":"cee96b4","82":"40cb432","83":"885c53e","84":"aa1ff65","85":"1430ade","86":"749430e","87":"f31326b","88":"8ff7c67","89":"616f698","90":"166ec6e","91":"4d2e2c6","92":"bbb9f5e","93":"00ff43f","94":"dbab613","95":"c84d878","96":"03d9083","97":"faa9063","98":"654fd23","99":"4a234b2","100":"eae5d0b","101":"b490534","102":"95b49e3","103":"53bbcc6","104":"427c99a","105":"50fb3d8","106":"e6e27b4","109":"5b8d19c","110":"300008c","111":"172fe1c","112":"3bea439","113":"3ea26dc","114":"7e2583b","115":"b9cf399","116":"8a342a7","117":"901217f","118":"050c7ab","119":"60d50c4","120":"8c9dc65","121":"9c75904","122":"02cf555","123":"626f20a","124":"c0b2cfa","125":"17cdd4b","126":"cff694e","127":"09dc70b","128":"3f8525d","129":"b3bf1cf","130":"c1da359","131":"6249648","132":"5579c5c","133":"6cf7b0d","134":"f297692","135":"426a893","136":"5a15ede","137":"bf51521","138":"ac2911f","139":"d1d34c6","140":"4446711","141":"f58349e","142":"91fc074","143":"989a4a6","144":"9802ec1","145":"cb96f98","146":"2e4d652","147":"77ca2d8","148":"f2a524d","149":"7253589","150":"c6c87ff","151":"eaa2452","152":"34b6586","153":"852317f","154":"a32889b","155":"22a5a85","156":"e80f915","157":"354a504","158":"cc6e6db","159":"3472323","160":"3445a80","161":"4814db7","162":"a52f35c","163":"2df34ff","164":"255ff24","165":"41e85f0","166":"c7a1542","167":"71f969c","168":"ae18301","169":"3a23692","170":"0b0a440","171":"121bcf2","172":"c9a422f","173":"d0742c1","174":"bb62444","175":"b2d4b0f","176":"7b6ea7b","177":"5eca65c","178":"9ac432d","179":"a594ea2","180":"b572ade","181":"f15e9e3","182":"5881716","183":"99e4227","184":"93a1582","185":"9837bbe","186":"67ef013","187":"f7b119f","188":"d9cc317","189":"0503f7a","190":"7916a51","191":"7e7d137","192":"520fc68","193":"c270b08","194":"a828578","195":"b98bfab","196":"2d65c2d","197":"95de5b0","198":"25e47f1","199":"b25fd20","200":"0b68992","201":"754643d","202":"72e7656","203":"f6bf96f","204":"bfdf7a2","205":"d8cbcd3","206":"f3576c2","207":"9be91be","208":"00694c1","209":"7c73bcf","210":"9cd3743","211":"5a710fc","212":"e45cd99","215":"8efe175","216":"8dd05fd","217":"b2060b0","218":"3d3764d","219":"8648515","220":"5f2b2b9","221":"3110046","222":"c7e3bb1","223":"9d7a557","224":"1b54354","225":"8216a64","226":"0c91e6f","227":"98e3961","228":"0fa25b9","229":"f7d14d0","230":"a873756","231":"721e3cc","232":"4cfa86e","233":"78f91b8","234":"8262676","235":"6c32ac0","236":"31b3b6f","237":"58111ff","238":"691e14a","239":"73dcc56","240":"0e61987","241":"bbec42e","242":"30a3010","243":"3e5067f","244":"a75c403","245":"d9890fd","246":"e68ae08","247":"6a00b35","248":"82063fa","249":"0cac7fb","250":"4f5df79","251":"f76a70f","252":"266e84e","253":"6c02c02","254":"6f4790a","255":"2f291a2","256":"0ed6d89","257":"38488ad","258":"ba6c0b3","259":"0b10e65","260":"bbc29c7","261":"e5801b1","262":"b619b15","263":"8cb8aab","264":"7017758","265":"8fe1f66","266":"ba3d23d","267":"cffc03b","268":"6d8ebfa","269":"56677ed","270":"9038d8c","271":"7d3c22b","272":"c61e643","273":"8cb2694","274":"924dcdc","275":"c268d1b","276":"23bc41d","277":"7a145f0","278":"f83ac5a","279":"55e201e","280":"96e9dca","281":"02dce55","282":"ecccbdc","283":"6879406","284":"be01db5","285":"ac082e2","286":"f3bbaab","287":"ced6ba6","288":"45a85a4","289":"d15f717","290":"de5ff96","291":"9e7e114","292":"a33d1c9","293":"6c93463","294":"6343f69","295":"ac41354","296":"be0cc1c","297":"8ac401e","298":"e5152a5","299":"4918f43","300":"9977d6e","301":"4900886","302":"01a84dc","303":"0c1a4d6","304":"851422b","305":"b329b71","306":"e589dfb","307":"754c4c9","308":"75f844c","309":"2e502c4","310":"565be4f","311":"8b0891f","312":"ae52355","313":"4f94611","314":"4bb3916","315":"a3a7796","316":"74de5cc","317":"8957b46","318":"d7d18d4","319":"b316742","320":"58778bc","321":"5ec4f0c","322":"9f932fa","323":"c26c39a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d2kaq61j235tiz.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
